import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

export const threeState = {
	controls: undefined as OrbitControls | undefined,
};
